import { render, staticRenderFns } from "./Step3Preview.vue?vue&type=template&id=28fa8d0a&scoped=true&"
import script from "./Step3Preview.vue?vue&type=script&lang=js&"
export * from "./Step3Preview.vue?vue&type=script&lang=js&"
import style0 from "./Step3Preview.vue?vue&type=style&index=0&id=28fa8d0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa8d0a",
  null
  
)

export default component.exports